(ns manage.content-variant-page.targeting-value.default
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.ui.store :as store]
            [datascript.core :as d]
            [manage.content-configuration-page.placeholder-expression.db :refer [singular-placeholder-expression]]
            [manage.content-variant-page.targeting-value.db]
            [re-frame.core :as rf]
            [re-posh.core :as rp]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

;; db

(rp/reg-query-sub :targeting-value/targeting-key-if-default
  '[:find ?tk . :in $ ?tv
    :where
    [?tv :targeting-value/placeholder-expression ?phe]
    [?p :placeholder/default-value ?phe]
    [?tk :targeting-key/placeholder ?p]])

(rp/reg-event-ds :targeting-value/set-as-default
  (fn [ds [_ tv]]
    (if-let [[p phe] (d/q '[:find [?p ?phe] :in $ ?tv
                            :where
                            [?tv :targeting-value/placeholder-expression ?phe]
                            [?p :placeholder/override ?phe]] ds tv)]
      ;; mapped
      [[:db/add p :placeholder/default-value phe]]
      ;; dynamic
      (let [[p value] (d/q '[:find [?p ?value] :in $ ?tv
                             :where
                             [?tk :targeting-key/targeting-value ?tv]
                             [?tv :targeting-value/value ?value]
                             [?tk :targeting-key/placeholder ?p]] ds tv)]
        [(assoc (singular-placeholder-expression [value] [] false)
                :placeholder/_default-value p
                :targeting-value/_placeholder-expression tv)]))))

;; UI

(defui is-default []
  ($ Typography {:fontWeight "600"} "default"))

(defui select-default [{:keys [tv]}]
  (let [is-published-version (use-subscribe [:resource.content-function-version/active-version? "published"])
        targeting-key (use-subscribe [:targeting-value/targeting-key-if-default tv])]
    (if (some? targeting-key)
      ($ is-default)
      ($ Button
         {:variant "text"
          :disabled is-published-version
          :onClick #(rf/dispatch [:targeting-value/set-as-default tv])}
         "Set as default"))))

(defui label-with-default [{:keys [tv]}]
  (let [value @(store/get-value tv :targeting-value/value)]
    ($ Stack
       {:direction "row"
        :alignItems "center"
        :justifyContent "space-between"}
       ($ :span value)
       ($ select-default {:tv (:eid tv)}))))

(defui label-without-default [{:keys [tv]}]
  (let [value @(store/get-value tv :targeting-value/value)]
    ($ :span value)))
